import React from 'react';
import { Map, List, CalendarCheck, MoreHorizontal } from 'lucide-react';
import logoSmall from '../NorthAI_Logo_Small_Zoomed_Dark.png';
import './BottomNav.css';

const BottomNav = ({
  currentView,
  onViewChange,
  onAIBriefing,
  onMenuOpen,
  visitCount = 0,
  isBriefingActive = false,
}) => {
  return (
    <nav className="bottom-nav" data-testid="bottom-nav">
      {/* Map */}
      <button
        className={`nav-item ${currentView === 'map' ? 'active' : ''}`}
        onClick={() => onViewChange('map')}
        data-testid="bottom-nav-map"
      >
        <Map size={22} />
        <span>Map</span>
      </button>

      {/* Visits */}
      <button
        className={`nav-item ${currentView === 'visits' ? 'active' : ''}`}
        onClick={() => onViewChange('visits')}
        data-testid="bottom-nav-visits"
      >
        <div className="relative inline-flex">
          <CalendarCheck size={22} />
          {visitCount > 0 && (
            <span className="absolute -top-1.5 -right-2.5 bg-purple-500 text-white text-[9px] font-bold w-4 h-4 rounded-full flex items-center justify-center leading-none">
              {visitCount > 9 ? '9+' : visitCount}
            </span>
          )}
        </div>
        <span>Visits</span>
      </button>

      {/* AI — raised centre pill */}
      <button
        className={`nav-item-ai${isBriefingActive ? ' briefing-active' : ''}`}
        onClick={onAIBriefing}
        data-testid="bottom-nav-ai"
        aria-label="AI Briefing"
      >
        <div className="nav-ai-pill">
          <img src={logoSmall} alt="AI" className="w-7 h-7 object-cover rounded-full" />
        </div>
        <span className="nav-ai-label">AI</span>
      </button>

      {/* List */}
      <button
        className={`nav-item ${currentView === 'list' ? 'active' : ''}`}
        onClick={() => onViewChange('list')}
        data-testid="bottom-nav-list"
      >
        <List size={22} />
        <span>List</span>
      </button>

      {/* Menu */}
      <button
        className="nav-item"
        onClick={onMenuOpen}
        data-testid="bottom-nav-menu"
      >
        <MoreHorizontal size={22} />
        <span>Menu</span>
      </button>
    </nav>
  );
};

export default BottomNav;
